import React, { useEffect } from "react";
import publices from "../../Asset/aboutus/publices.png";
import Frame from "../../Asset/aboutus/Frame.jpg";
import logo from "../../Asset/login/logo.png";
import grass from "../../Asset/aboutus/grass.svg";
import side from "../../Asset/aboutus/side.png";
import easy from "../../Asset/aboutus/easy.png";
import health from "../../Asset/aboutus/health.png";
import community from "../../Asset/aboutus/community.png";
import susbility from "../../Asset/aboutus/susbility.png";
import back from "../../Asset/aboutus/back.jpg";
import patato from "../../Asset/aboutus/patato.svg";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      
    });
  }, []);
  return (
    <div className="w-full bg-Background3   ">
      <div
        className="w-full md:h-screen  h-fit"
        style={{
          backgroundImage: `url(${Frame})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full h-full flex justify-end md:items-center items-start" data-aos="fade-right">
          <div className="w-full md:w-2/3  bg-white/40 flex items-center justify-center rounded-l-2xl px-4 py-16 md:p-20" >
            <div className="flex flex-col  md:w-1/2 w-full  justify-start">
              <span className="text-xl md:text-4xl font-bold">About Sehatful</span>
              <p className="mt-3 md:mt-10 text-base md:text-xl">
                your trusted source for wholesome, nutrient-rich grains and
                healthy food products! At NourishGrains, we believe that good
                health starts with what you put on your plate
              </p>
              <div className="w-full mt-10">
                <div className="w-1/2 h-full">
                  <img
                    src={logo}
                    alt="img"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div >
      <div className="w-full relative" data-aos="flip-left" >
        {/* Main container */}
        <div className="w-full px-4 md:px-12  relative z-10" >
          <div className="bg-Background1 relative z-10 flex justify-center pb-24 shadow-xl shadow-Background2 w-full h-4/5 rounded-tl-4xl rounded-tr-8xl rounded-br-4xl rounded-b-4xl md:rounded-bl-8xl"  >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 h-4/5 w-11/12 md:pt-20 pt-2" >
              <div className="w-full h-full flex flex-col" >
                <div className="md:mt-16 mt-24"  >
                  <span className="md:text-4xl text-xl font-bold" >
                    Who We Are ?
                  </span>
                </div>
                <p className="text-wrap text-base md:text-lg mt-5 md:mt-16" >
                  We are a team of health enthusiasts, nutritionists, and food
                  lovers who are passionate about promoting a healthier
                  lifestyle...
                </p>
              </div>
              <div className="w-full h-full flex justify-end">
                <div className="w-3/4">
                  <img
                    src={publices}
                    alt="img"
                    className="w-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Grass image behind the box at bottom */}
        <div className="w-full absolute -bottom-[60px] sm:-bottom-200px] md:-bottom-[150px] lg:-bottom-[200px] z-0">
          <img src={grass} alt="grass" className="w-full object-cover" />
        </div>
      </div>
      </div>
      <div className="w-full pb-20 px-5 md:px-12 flex md:flex-row flex-col  gap-8 mt-20 md:mt-24 lg:mt-28 ">
        <div className="lg:w-1/3 w-full" data-aos="zoom-in">
          <div className="w-full ">
            <img src={side} alt="img" className="w-full  object-cover" />
          </div>
        </div>
        <div className="w-full h-full flex flex-col  ">
          <div className="flex justify-between items-center mt-2 lg:mt-8">
            <span className="text-2xl lg:text-4xl font-bold" >
              What We Offer ?
            </span>
            <div >
              <img src={patato} alt="img" />
            </div>
          </div>
          <div className="flex mt-4 lg:mt-10 gap-5" data-aos="fade-right"  >
            <div className="w-9 h-9">
              <img
                src={easy}
                alt="img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="text-xl text-textColor" >Easy to Digest</span>
              <span>
                We rigorously test and select our products to meet the highest
                standards
              </span>
            </div>
          </div>
          <div className="flex mt-4 lg:mt-10 gap-5"  data-aos="fade-right" >
            <div className="w-9 h-9">
              <img
                src={health}
                alt="img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="text-xl text-textColor">
                Health-Conscious Options
              </span>
              <span>
                Our grains are packed with essential nutrients, fiber, and
                antioxidants to support your well-being
              </span>
            </div>
          </div>
          <div className="flex mt-4 lg:mt-10 gap-5" data-aos="fade-right" >
            <div className="w-9 h-9">
              <img
                src={community}
                alt="img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="text-xl text-textColor">Community Focused</span>
              <span>
                We believe in giving back and supporting local communities
                through partnerships and initiatives
              </span>
            </div>
          </div>
          <div className="flex mt-4 lg:mt-10 gap-5"  data-aos="fade-right">
            <div className="w-9 h-9">
              <img
                src={susbility}
                alt="img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="text-xl text-textColor">
                Sustainability Matters
              </span>
              <span>
                We’re committed to reducing our environmental footprint by
                supporting sustainable farming and eco-friendly packaging
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-full md:h-screen flex  md:items-center items-start"
        style={{
          backgroundImage: `url(${back})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        
      >
        <div className="md:w-2/3 w-11/12 pl-16 flex flex-col " >
          <span className=" text-2xl md:text-4xl font-bold mb-10 md:mb-20" data-aos="fade-right" >Our Vision</span>
          <p className="text-base md:text-lg mt-5 md:mt-10" data-aos="fade-right">
            At Sehatful, we envision a world where everyone has access to
            healthy, affordable, and delicious food options. We’re here to
            inspire you to make better food choices, one grain at a time.
            Whether you’re a seasoned health enthusiast or just starting your
            wellness journey, we’re here to support you every step of the way.
          </p>
          <p className="text-base md:text-lg mt-10" data-aos="fade-right">
            Join us in embracing a healthier, happier lifestyle. Explore our
            products, try our recipes, and discover the difference that
            wholesome grains can make in your life.
          </p>
          <p className="text-base md:text-lg mt-10" data-aos="fade-right">
          Thank you for choosing Sehatful – where good health begins with every bite!
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
